import { gql } from '@apollo/client';

export const PEOPLE_QUERY = gql`
  query People($page: Int, $size: Int, $filters: PeopleFilterInput) {
    people(page: $page, size: $size, filters: $filters) {
      list {
        id
        first_name
        last_name
        uuid
      }
    }
  }
`;

export const TYPE_OF_TASKS_QUERY = gql`
  query TypeOfTasks {
    type_of_tasks {
      name
      id
    }
  }
`;

export const TASKS_LIST_QUERY = gql`
  query TasksList($page: Int, $size: Int, $sort_column: String, $sort_direction: String, $filters: TaskFilter) {
    tasks(page: $page, size: $size, sort_column: $sort_column, sort_direction: $sort_direction, filters: $filters) {
      list {
        id
        name
        project {
          id
          name
          number
        }
        element {
          id
          name
          number
        }
        companies {
          id
          name
        }
        start_date
        end_date
        task_type {
          id
          name
        }
        priority
        complete
        board_column {
          id
          name
          board {
            id
            name
          }
        }
        responsible {
          id
          first_name
          last_name
          uuid
        }
        description
        created_at
        updated_at
        created_by
        updated_by
        attachments {
          id
          data_file_name
          url
        }
      }
      metadata {
        current_page
        next_page
        prev_page
        total_count
        total_pages
      }
    }
  }
`;

export const CREATE_OR_UPDATE_TASK = gql`
  mutation CreateOrUpdateTask(
    $id: ID
    $name: String
    $project_id: Int
    $element_id: Int
    $company_ids: [Int]
    $start_date: String
    $end_date: String
    $dictionary_task_type_ids: [Int]
    $priority: Int
    $complete: Int
    $board_column_id: Int
    $responsible_ids: [Int]
    $description: String
  ) {
    createOrUpdateTask(
      id: $id
      name: $name
      project_id: $project_id
      element_id: $element_id
      company_ids: $company_ids
      start_date: $start_date
      end_date: $end_date
      dictionary_task_type_ids: $dictionary_task_type_ids
      priority: $priority
      complete: $complete
      board_column_id: $board_column_id
      responsible_ids: $responsible_ids
      description: $description
    ) {
      errors
      task {
        id
        name
      }
    }
  }
`;

export const DELETE_TASK = gql`
  mutation DeleteTask($id: ID!) {
    destroyTask(id: $id) {
      response
    }
  }
`;

export const TASK_QUERY = gql`
  query Task($id: ID!) {
    task(id: $id) {
      id
      name
      board_column {
        id
        name
        board {
          id
          name
        }
      }
      companies {
        id
        name
      }
      responsible {
        id
        first_name
        last_name
        uuid
      }
      project {
        id
        name
        number
      }
      element {
        id
        name
        number
      }
      task_type {
        id
        name
      }
      start_date
      end_date
      description
      priority
      complete
      created_at
      updated_at
      created_by
      updated_by
      attachments {
        id
        data_file_name
        url
        thumb_url
      }
      task_progress {
        id
        content
        progress
        end_date
        created_at
        created_by
        attachments {
          id
          data_file_name
          url
        }
      }
    }
  }
`;

export const CREATE_OR_UPDATE_TYPE_OF_TASK = gql`
  mutation CreateOrUpdateTypeOfTask($name: String!) {
    createOrUpdateTypeOfTask(name: $name) {
      type_of_task {
        id
        name
      }
      errors
    }
  }
`;